import { ITsLePhiBuocNhaySaveRequest } from "../../model/request/category/tsLePhiBuocNhaySaveRequest";
import { apiClient } from "../apiClient";

export const LE_PHI_BUOC_NHAY_ENDPOINT = "le-phi-buoc-nhay";
export const lePhiBuocNhayApi = {
  SelectByDot: (id_dot_tuyen: number) =>
    apiClient.get(`${LE_PHI_BUOC_NHAY_ENDPOINT}/select-by-dot/${id_dot_tuyen}`),
  Save: (payload: ITsLePhiBuocNhaySaveRequest) =>
    apiClient.post(`${LE_PHI_BUOC_NHAY_ENDPOINT}/save`, payload),
};
